const hamburger = document.querySelector('.hamburger-menu');
const mobileMenu = document.getElementById('mobile-menu');

if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.contains('is-open');
    hamburger.setAttribute('aria-expanded', (!isOpen).toString());
    mobileMenu.classList.toggle('is-open');
  });
}
